import { fetchApi } from "./fetchApi";

export default {
  get(packId, serviceAreaId) {
    return fetchApi({
      method: "get",
      url: `/api/memberPack/pack/${packId}/serviceArea/${serviceAreaId}`,
    }).catch(err => {
      // If the resource isn't found, normalize to an empty payload so callers don't have
      // to special-case 404 when the backend will create the record on upsert.
      if (err && err.response && err.response.status === 404) {
        return Promise.resolve({ data: {} });
      }
      return Promise.reject(err);
    });
  },

  upsert(packId, serviceAreaId, data) {
    return fetchApi({
      method: "post",
      url: `/api/memberPack/pack/${packId}/serviceArea/${serviceAreaId}`,
      data,
    });
  },
};
